/**
 * Mermaid `gantt` → DiagramData (matching the other importers' `{ data, warnings }`
 * shape). Composes the parser (text → resolved task model) with the deterministic
 * Gantt layout. NO dagre.
 */

import type { DiagramData } from '../types/schema'
import { parseMermaidGantt } from './mermaidGantt'
import { buildGanttDiagram } from './ganttLayout'

export interface MermaidGanttImportResult {
  data: DiagramData
  warnings: string[]
}

export function parseMermaidGanttDiagram(text: string): MermaidGanttImportResult {
  const { model, warnings } = parseMermaidGantt(text)
  return { data: buildGanttDiagram(model), warnings }
}
